<template>
  <!-- 我的评价 -->
  <div class="Myevaluation">
    <div class="box">
      <div class="Thehead">
        <h5 class="Learning">我的评价</h5>
        <el-menu
          :default-active="sckecxx"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            :style="{ color: sckecxx == '课程评价' ? ' #4CCAFF' : '#000' }"
            index="课程评价"
            >课程评价</el-menu-item
          >
          <el-menu-item
            v-if="$store.state.user.dentitys == '评委员'"
            :style="{ color: sckecxx == '科普/论文评分' ? ' #4CCAFF' : '#000' }"
            index="科普/论文评分"
            >科普/论文评分</el-menu-item
          >
          <el-menu-item
            :style="{ color: sckecxx == '素材评价' ? ' #4CCAFF' : '#000' }"
            index="素材评价"
            >素材评价</el-menu-item
          >
        </el-menu>
        <span
          v-if="sckecxx !== '科普/论文评分'"
          class="xxjl"
          @click="sckecxx === '课程评价' ? delrateiss(1) : delscratep()"
        >
          <i class="iconfont gos-shanchu"></i> 清除全部记录</span
        >
        <!--
        <div
          style="display: flex; align-items: center; height: 20px"
          v-if="sckecxx == '科普/论文评分'"
        >
          <span
            style="font-size: 13px; color: #333; font-weight: 500; width: 100px"
            >筛选 ：</span
          >
          <el-select
            @change="selitemis()"
            v-model="scvalue"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
        <!-- <div class="searchbox">
          <el-input placeholder="请输入内容" size="mini" v-model="name">
            <template slot="append"
              ><el-button
                v-if="sckecxx == '课程评价'"
                @click="selratelistis()"
                round
                >搜索</el-button
              >
              <el-button
                v-if="sckecxx == '素材评价'"
                @click="selratesclistis()"
                round
                >搜索</el-button
              >
            </template>
          </el-input>
        </div> -->
      </div>
      <ul class="Course" v-if="sckecxx == '课程评价'">
        <li class="Live1" v-for="(item, index) in tepsm" :key="index">
          <video
            class="videois"
            @click.stop="jump(item)"
            :src="http + item.sp"
          ></video>

          <div class="thevideo">
            <h4 @click.stop="jump(item)">{{ item.name }}</h4>
            <p class="wb" @click.stop="jump(item)" v-html="item.kcjs"></p>
            <div class="jejq">
              <span class="je" @click.stop="jump(item)">{{ item.jg }}</span>
              <div>
                <!-- <img src="../assets/dianz.png" alt="" /> -->
                <!-- <i  style="margin-right: 9px;" class="iconfont gos-dianzan"></i> -->
                <p class="dzs">平均分：{{ item.pf }}</p>
              </div>
            </div>
            <div class="collection">
              <span class="dzs"
                ><div class="block">
                  <el-rate disabled v-model="item.rate"> </el-rate>
                </div>
              </span>
              <span class="Buynow" @click="delrateis(item)">删除评价</span>
            </div>
          </div>
        </li>
      </ul>

      <ul class="Coursess" v-if="sckecxx == '素材评价'">
        <li class="Live1" v-for="item in toeppfsc" :key="item.id">
          <video
            class="videois"
            @click="Materialtojump(item.id)"
            v-if="item.wjgs === '视频'"
            :src="http + item.scwj"
          ></video>
          <img
            class="videois"
            @click="Materialtojump(item.id)"
            v-if="item.wjgs === '图片' || item.wjgs === '动图'"
            style="cursor: pointer; width: 247px; height: 150px"
            :src="http + item.scwj"
            alt=""
          />
          <div class="thevideo">
            <div class="nameh" @click="Materialtojump(item.id)">
              <h4>{{ item.scmc }}</h4>
              <span>{{ item.wjgs }}</span>
            </div>
            <div class="jejq">
              <span class="je">{{ item.sfff }}</span>
              <div>
                <i
                  style="
                    font-size: 14px;
                    color: #999999;
                    line-height: 18px;
                    margin-right: 10px;
                  "
                  class="iconfont gos-yanjing1"
                >
                </i>
                <span style="color: #999999" class="right-collection"
                  >浏览里 &nbsp;{{ item.ll }}</span
                >
              </div>
            </div>
            <div class="collectionsss">
              <span class="dzs"
                ><div class="block">
                  <el-rate disabled v-model="item.rate"> </el-rate>
                </div>
              </span>
              <span class="Buynow" @click="delscrate(item.id)">删除评价</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="buttom" v-if="sckecxx == '科普/论文评分'">
        <ul class="Course">
          <li class="Live1" v-for="(iten, index) in tableData" :key="index">
            <video
              v-if="iten.know.sorts == '视频'"
              poster=""
              class="videois"
              @click="jump1(iten.know)"
              :src="http + iten.know.video"
              controls
            ></video>
            <el-image
              v-else
              class="videois"
              :src="iten.know.picture ? iten.know.picture : commonIMG"
              alt=""
            />
            <div class="thevideo">
              <div style="display: flex">
                <div class="thename" @click="jump1(iten.know)">
                  {{ iten.know.name }}
                </div>
                <el-rate
                  class="elra"
                  style="transform: scale(1.3)"
                  v-model="iten.know.score"
                  disabled
                  show-score
                  text-color="#f86626"
                  score-template="{value}"
                >
                </el-rate>
                <i
                  class="el-icon-star-on"
                  style="color: #f86626; font-size: 18px"
                >
                  {{ iten.know.score }}</i
                >
              </div>
              <p
                class="wb"
                @click="jump1(iten.know)"
                v-html="iten.know.content"
              ></p>

              <div class="collection">
                <span class="dzs" @click="eacherpage(iten.know.user.id)"
                  ><img
                    class="imgssz"
                    :src="http + iten.know.user.tx"
                    alt=""
                  />{{ iten.know.user.name }}</span
                >
                <div class="jejq">
                  <!-- <span class="je">{{ iten.jg }}</span> -->
                  <div style="margin-right: 20px">
                    <i
                      style="font-size: 14px; color: #999999; margin-top: 8px"
                      class="iconfont gos-yanjing1"
                    ></i>
                    <p class="dzs">浏览量：{{ iten.know.ll }}</p>
                  </div>
                  <div style="margin-right: 20px">
                    <p class="dzs">
                      {{ iten.know.knowdate }}
                    </p>
                  </div>
                  <div>
                    <span class="dzs">我的评分</span>
                    <el-rate
                      class="rate"
                      style="margin-top: 1px"
                      disabled
                      v-model.number="iten.score"
                    ></el-rate>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <el-pagination
          v-if="this.paging.total !== 0"
          @current-change="handleCurrentChange"
          :page-size="paging.rows"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="prev, pager, next"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-pagination
      v-if="sckecxx === '课程评价'"
      class="paging"
      background
      prev-text="上一页"
      next-text="下一页"
      @current-change="handleCurrentChangess"
      :page-size="tepage.rows"
      layout="prev, pager, next"
      :total="tepage.total"
    >
    </el-pagination>
    <el-pagination
      v-if="sckecxx === '素材评价'"
      class="paging"
      background
      prev-text="上一页"
      next-text="下一页"
      @current-change="handleCurrentChangesss"
      :page-size="tepagesc.rows"
      layout="prev, pager, next"
      :total="tepagesc.total"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  selratelist,
  insrate,
  delrate,
  selratesclist,
  delscrate,
  selscore,
} from "../../../api/patient";

export default {
  data() {
    return {
      srate: "",
      sckecxx: "课程评价",
      setz: false,
      http: this.$store.state.https,
      value1: 0,
      input2: "",
      name: "",
      commonIMG: require("../../../assets/common/jkkp.png"),
      tepsm: {},
      tepage: {
        page: 1,
        rows: 9,
        total: 100,
      },
      tepagesc: {
        page: 1,
        rows: 9,
        total: 100,
      },
      toeppfsc: [],
      tableData: [],
      paging: {
        page: 1,
        rows: 10,
        total: 50,
      },
      scvalue: "全部",
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "文章",
          label: "文章",
        },
        {
          value: "视频",
          label: "视频",
        },
      ],
    };
  },
  created() {
    this.sckecxx = this.$store.state.scxx;
    this.selratelistis();
    this.selratesclistis();
    this.selitemis();
  },
  methods: {
    // 跳转老师页面
    eacherpage(item) {
      this.$router.push(`/TeacherDetailsPage/${item}`);
    },
    async selitemis() {
      var data = new FormData();
      data.append("page", this.paging.page);
      data.append("rows", this.paging.rows);
      data.append("phone", this.$store.state.user.phone);
      // if (this.scvalue !== "全部") {
      //   data.append("sorts", this.scvalue);
      // }
      var res = await selscore(data);
      console.log(res);
      this.tableData = res.records;
      this.paging.total = res.totalCount;
      // for (let i = 0; i < this.tableData.length; i++) {
      //   this.tableData[i].pf = Number(this.tableData[i].pf);
      // }
    },
    // 素材跳转
    Materialtojump(item) {
      this.$router.push("/materialdetailspage");
      this.$store.commit("sucaixingqi", item);
    },
    // 批量删除
    delscratep() {
      if (this.toeppfsc.length !== 0) {
        var data = new FormData();
        data.append("userid", this.$store.state.user.id);
        delscrate(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selratesclistis();
          }
        });
      }
    },
    // 单删
    delscrate(item) {
      var data = new FormData();
      data.append("userid", this.$store.state.user.id);
      data.append("itemid", item);
      delscrate(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selratesclistis();
        }
      });
    },
    // 素材评分列表
    selratesclistis() {
      var data = new FormData();
      data.append("id", this.$store.state.user.id);
      data.append("page", this.tepagesc.page);
      data.append("rows", this.tepagesc.rows);
      if (this.name) {
        data.append("name", this.name);
      }
      selratesclist(data).then((res) => {
        this.toeppfsc = res.rows;
        this.tepagesc.total = res.total;
        for (let s = 0; s < this.toeppfsc.length; s++) {
          this.toeppfsc[s].rate = Number(this.toeppfsc[s].rate);
        }
      });
    },
    // 导航栏切换
    handleSelect(val) {
      this.$store.commit("scrxi", val);
      this.sckecxx = this.$store.state.scxx;
    },
    // 全部删除
    delrateiss(item) {
      if (this.tepsm.length !== 0) {
        var data = new FormData();
        data.append("userid", this.$store.state.user.id);
        delrate(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selratelistis();
          }
        });
      }
    },
    // 单删
    delrateis(item) {
      var data = new FormData();
      data.append("itemid", item.id);
      data.append("userid", this.$store.state.user.id);
      delrate(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selratelistis();
        }
      });
    },
    jump1(item) {
      this.$store.commit("Jumpfordetails", item.id);
      if (item.sorts == "视频") {
        this.$router.push("/PopularScienceDetails");
      } else {
        this.$router.push("/ArticleDetails");
      }
    },
    // 跳转
    jump(item) {
      this.$router.push("/coursedetailspage");
      this.$store.commit("Jumpfordetails", item.id);
    },
    // 评分
    insrateis(item) {
      var data = new FormData();
      data.append("rate", item.rate);
      data.append("itemid", item.id);
      data.append("userid", this.$store.state.user.id);
      insrate(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selratelistis();
        }
      });
    },
    // 列表
    selratelistis() {
      var data = new FormData();
      data.append("id", this.$store.state.user.id);
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);

      if (this.name) {
        data.append("name", this.name);
      }
      selratelist(data).then((res) => {
        this.tepsm = res.rows;
        this.tepage.total = res.total;
        for (let s = 0; s < this.tepsm.length; s++) {
          this.tepsm[s].rate = Number(this.tepsm[s].rate);
        }
      });
    },
    handleCurrentChange(val) {
      this.paging.page = val;
      this.selitemis();
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selratelistis();
    },
    handleCurrentChangesss(val) {
      this.tepagesc.page = val;
      this.selratesclistis();
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  min-height: 725px;
  .Learning {
    text-align: left;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
}
.imgssz {
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}
.Course {
  display: flex;
  width: 100%;
  // min-height: 700px;
  justify-content: flex-start;
  flex-wrap: wrap;
  .Live1 {
    margin-right: 13px;
    width: 240px;
    height: 299px;
    background: #ffffff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    margin-bottom: 20px;
    transition: all 0.2s;
    .videois {
      width: 240px;
      height: 151px;
      border-radius: 6px 6px 0px 0px;
      cursor: pointer;
    }
    .thevideo {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      h4 {
        cursor: pointer;
        white-space: nowrap;
        // width: 126px;
        display: flex;
        height: 14px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      .wb {
        cursor: pointer;
        display: flex;
        text-align: left;
        width: 220px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        display: -webkit-box; /**对象作为伸缩盒子模型展示**/
        -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
        -webkit-line-clamp: 3; /**显示的行数**/
        overflow: hidden; /**隐藏超出的内容**/
      }
      .jejq {
        margin-top: 2px;
        display: flex;
        justify-content: space-between;
        .je {
          width: 66px;
          text-align: left;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ff1616;
        }
        div {
          display: flex;
          img {
            width: 12px;
            height: 12px;
            line-height: 12px;
            margin-right: 8px;
            padding-top: 2px;
          }
          .dzs {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
      .collection {
        // padding-top: 10px;
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #f6f6f6;
        .dzs {
          white-space: nowrap;
          height: 13px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
        }
        .Buynow {
          cursor: pointer;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #4ccaff;
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
}
.searchbox {
  width: 255px;
  ::v-deep .el-input__inner {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-top-right-radius: 15px;
    // border-bottom-right-radius: 15px;
  }
  ::v-deep .el-input-group__append {
    margin-left: 100px;
    // line-height: 30px;
    border: 0px;
    background: #fff;
    .el-button {
      position: relative;
      left: -10px;
      top: -1px;
      padding: 0px;
      width: 70px;
      height: 30px;
      background: #4ccaff;
      border: 1px solid #ededed;
      border-radius: 15px;
      color: #fff;
    }
  }
}
.Thehead {
  margin-top: 29px;
  display: flex;
  margin-bottom: 17px;
  span {
    margin-left: 520px;
  }
  .el-menu-demo {
    padding: 0;
    height: 30px;
    width: 40px;
    margin-left: 30px;
    line-height: 40px;
    border: 0px;
    display: flex;

    .el-menu-item {
      margin-left: 20px;
      padding: 0 5px;

      height: 30px;
      line-height: 24px;
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      // color: #4CCAFF;
    }
    ::v-deep.is-active {
      border-bottom: 2px solid #4ccaff;
    }
  }
}
.xxjl {
  margin-right: 20px;
  cursor: pointer;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  line-height: 28px;
}
.paging {
  margin-bottom: 70px;
}
.buttom {
  margin-top: 27px;

  .Course {
    display: flex;
    width: 100%;
    justify-content: left;
    flex-wrap: wrap;
    .Live1 {
      display: flex;
      width: 750px;
      height: 110px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      border-radius: 6px;
      margin-bottom: 20px;
      transition: all 0.2s;
      margin-left: 17px;
      .videois {
        // width: 144.6px;
        width: 170.6px;
        height: 87.6px;
        padding: 10px 10px;
        border-radius: 6px 6px 0px 0px;
        object-fit: contain;
      }
      .thevideo {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 10px 10px 10px 0px;
        .el-icon-star-on {
          display: none;
        }
        .thename {
          font-size: 15px;
          // height: 48px;
          width: 420px;
          text-align: left;
          font-weight: bold;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .wb {
          display: flex;
          text-align: left;
          cursor: pointer;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 2; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
          font-size: 12px;
          line-height: 26px;
        }

        .collection {
          // padding-top: 6px;
          // margin-top: 5px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-top: 2px solid #f6f6f6;
          .jejq {
            // margin-top: 3px;
            display: flex;
            justify-content: space-between;
            .je {
              // width: 66px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ff1616;
            }
            div {
              display: flex;
              align-items: center;
              img {
                width: 12px;
                height: 12px;
                line-height: 12px;
                margin-right: 8px;
                padding-top: 2px;
              }
              .dzs {
                font-size: 12px;
                margin-left: 5px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
              }
            }
          }
          .dzs {
            cursor: pointer;
            white-space: nowrap;
            // height: 13px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999;
          }
          .Buynow {
            cursor: pointer;
            white-space: nowrap;
            // display: flex;
            text-align: center;
            width: 67px;
            height: 23px;
            background: #4ccaff;
            border-radius: 4px;
            border: 1px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
          .Buynow:hover {
            background: #4ccaffc9;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .el-pagination {
    margin-top: 60px;
    margin-bottom: 30px;
  }
}
.Coursess {
  display: flex;
  width: 100%;
  // min-height: 1000px;

  flex-wrap: wrap;
  .Live1 {
    margin-right: 13px;
    width: 240px;
    height: 265px;
    background: #ffffff;
    border: 1px solid #f6f6f6;
    border-radius: 6px;
    margin-bottom: 20px;
    transition: all 0.2s;
    video {
      width: 247px;
      height: 151px;
      border-radius: 6px 6px 0px 0px;
      cursor: pointer;
    }
    .thevideo {
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      .nameh {
        // margin-bottom:px ;
        text-align: left;
        display: flex;
        justify-content: space-between;
        h4 {
          cursor: pointer;
          white-space: nowrap;
          width: 126px;
          display: flex;
          height: 16px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          display: -webkit-box; /**对象作为伸缩盒子模型展示**/
          -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
          -webkit-line-clamp: 1; /**显示的行数**/
          overflow: hidden; /**隐藏超出的内容**/
        }

        span {
          cursor: pointer;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
      }

      .jejq {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        .je {
          text-align: left;
          width: 66px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ff1616;
        }
        div {
          display: flex;
          .dzs {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #4ccaff;
          }
        }
      }
      .collectionsss {
        padding-top: 10px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #f6f6f6;
        .Buynow {
          cursor: pointer;
          padding: 0px;
          width: 67px;
          height: 23px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #4ccaff;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #ffffff;
        }
      }
    }
  }
  .Live1:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
img {
  object-fit: contain;
}
// 适配手机端
@media (max-width: 768px) {
  .box {
    min-height: 725px;
    .Learning {
      text-align: left;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
    }
  }
  .imgssz {
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 10px;
  }
  .Course {
    width: 98vw;
    margin: auto;
    .Live1 {
      width: 45vw;
      height: 245px;
      margin-left: 5px;
      margin-right: 5px;
      .videois {
        width: 45vw;
        height: 100px;
      }
      .thevideo {
        padding: 5px;
        .theh4 {
          width: 160px;
        }
        .wb {
          width: 160px;
        }
        .collection {
          .dzs {
            width: 30vw;
          }
        }
      }
    }
  }
  .searchbox {
    width: 255px;
    ::v-deep .el-input__inner {
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      // border-top-right-radius: 15px;
      // border-bottom-right-radius: 15px;
    }
    ::v-deep .el-input-group__append {
      margin-left: 100px;
      // line-height: 30px;
      border: 0px;
      background: #fff;
      .el-button {
        position: relative;
        left: -10px;
        top: -1px;
        padding: 0px;
        width: 70px;
        height: 30px;
        background: #4ccaff;
        border: 1px solid #ededed;
        border-radius: 15px;
        color: #fff;
      }
    }
  }
  .Thehead {
    margin-top: 29px;
    display: block;
    margin-bottom: 17px;
    margin-left: 10px;
    span {
      display: block;
      margin-left: 60vw;
      margin-top: 20px;
    }
    .el-menu-demo {
      margin-top: 20px;
    }
  }
  .xxjl {
    margin-right: 20px;
    cursor: pointer;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
    line-height: 28px;
  }
  .paging {
    margin-bottom: 70px;
  }
  .buttom {
    margin-top: 27px;
    .Course {
      .Live1 {
        width: 95vw;
        margin-left: 10px;
        .videois {
          // width: 144.6px;
          width: 30vw;
          height: 87.6px;
          padding: 10px 10px;
          border-radius: 6px 6px 0px 0px;
          object-fit: contain;
        }
        .thevideo {
          width: 55vw;
          .elra {
            display: none;
          }
          .el-icon-star-on {
            display: block;
          }
          .thename {
            width: 40vw;
          }
          .wb {
            display: flex;
            text-align: left;
            cursor: pointer;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 2; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
            font-size: 12px;
            line-height: 22px;
          }

          .collection {
            // padding-top: 6px;
            // margin-top: 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-top: 2px solid #f6f6f6;
            .jejq {
              // margin-top: 3px;
              display: flex;
              justify-content: space-between;
              .je {
                // width: 66px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #ff1616;
              }
              div {
                display: flex;

                img {
                  display: none;
                }
                .gos-yanjing1 {
                  display: none;
                }
                .dzs {
                  display: none;
                }
                .rate {
                  margin-left: -20px;
                  margin-bottom: -10px;
                }
              }
            }
            .dzs {
              cursor: pointer;
              white-space: nowrap;
              // height: 13px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999;
            }
            .Buynow {
              cursor: pointer;
              white-space: nowrap;
              // display: flex;
              text-align: center;
              width: 67px;
              height: 23px;
              background: #4ccaff;
              border-radius: 4px;
              border: 1px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
            }
            .Buynow:hover {
              background: #4ccaffc9;
            }
          }
        }
      }
      .Live1:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
      }
    }
    .el-pagination {
      margin-top: 60px;
      margin-bottom: 30px;
    }
  }
  .Coursess {
    .Live1 {
      width: 45vw;
      height: 245px;
      margin-left: 5px;
      margin-right: 5px;
      .videois {
        width: 45vw !important;
        height: 100px;
      }
      .thevideo {
        padding: 5px;
        .theh4 {
          width: 160px;
        }
        .wb {
          width: 160px;
        }
        .collectionsss {
          padding-top: 10px;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #f6f6f6;
          .Buynow {
            cursor: pointer;
            padding: 0px;
            width: 60px;
            height: 23px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #4ccaff;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            // color: #ffffff;
          }
          .dzs {
            margin-left: -8px;
            width: 35vw;
          }
        }
      }
    }
    .Live1:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
    }
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 10px;
    }
  }
  img {
    object-fit: contain;
  }
}
</style>
